import { PortalSwitchClient } from "@/features/portal/components/auth/portal-switch-client";

/** `/portal/switch-client` — re-pick among linked clients for this session. */
export default function SwitchClientPage() {
  return <PortalSwitchClient />;
}
